// import Swiper from 'swiper';
import remodal from 'remodal';

// スクロールアニメーション（各.animを個別に判定、表示時にアニメーション発火）
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	document.readyState === 'complete' ? check() : window.addEventListener('load', check, { once: true });
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// 背景アニメーション（.area通過で.bg pにactiveを付加）
const funcBg = () => {
	const areas = document.querySelectorAll('.area');
	const layers = document.querySelectorAll('.bg p');
	if (!areas.length || !layers.length) return;

	const areasArray = [...areas];
	const check = (entries) => {
		entries.forEach((entry) => {
			const index = areasArray.indexOf(entry.target);
			if (index === -1) return;

			if (entry.isIntersecting) {
				layers.forEach((item) => item.classList.remove('active'));
				if (layers[index]) layers[index].classList.add('active');
			} else {
				if (layers[index]) layers[index].classList.remove('active');
			}
		});
	};

	const options = {
		rootMargin: '0px 0px -10% 0px',
		threshold: 0,
	};

	const observer = new IntersectionObserver(check, options);
	areas.forEach((target) => observer.observe(target));
};

// ヘッディングアニメーション（.contents上辺でadd、下辺でremove）
const funcHead = () => {
	const trigger = document.querySelector('.contents');
	const headings = document.querySelectorAll('.heading');
	if (!trigger || !headings.length) return;

	const check = () => {
		const r = trigger.getBoundingClientRect();
		const vh = window.innerHeight;
		const inView = r.top <= 0 && (r.height > vh ? r.bottom > vh : r.bottom > 0);
		headings.forEach((el) => el.classList.toggle('active', inView));
	};

	document.readyState === 'complete' ? check() : window.addEventListener('load', check, { once: true });
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// スムーススクロール
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const duration = 500;

window.addEventListener('DOMContentLoaded', () => {
	const triggers = document.querySelectorAll('.anchor');

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();

			const currentPosition = window.scrollY || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 0;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);
				}
			};

			requestAnimationFrame(loop);
		});
	});

	// スクロールアニメーション;
	funcAnim();

	// 背景アニメーション;
	funcBg();

	// ヘッディングアニメーション;
	funcHead();
});
